import React from 'react';
import { AlertCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../../components/ui/tooltip';

export const ModuleTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'prescreen', label: 'Pre-screen', disabled: false },
    { id: 'dpia', label: 'DPIA', disabled: false },
    { id: 'lia', label: 'LIA', disabled: false },
    { id: 'tia', label: 'TIA', disabled: false },
    { id: 'ai', label: 'AI Assessment', disabled: true, comingSoon: true },
  ];

  return (
    <div className="flex items-center gap-2 border-b border-muted overflow-x-auto">
      {tabs.map((tab) => (
        <div key={tab.id}>
          {tab.disabled ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div
                    className="px-4 py-3 text-sm font-medium uppercase tracking-wider text-muted-foreground cursor-not-allowed opacity-50 flex items-center gap-2"
                    data-testid={`tab-${tab.id}`}
                  >
                    {tab.label}
                    {tab.comingSoon && (
                      <>
                        <span className="inline-flex items-center gap-1 px-2 py-1 rounded bg-amber-50 dark:bg-amber-950 text-amber-700 dark:text-amber-300 text-xs font-semibold">
                          <AlertCircle className="h-3 w-3" />
                          Coming soon
                        </span>
                      </>
                    )}
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  AI Assessment module is under development
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : (
            <button
              onClick={() => onTabChange(tab.id)}
              className={`px-4 py-3 text-sm font-medium uppercase tracking-wider whitespace-nowrap transition-all ${
                activeTab === tab.id
                  ? 'text-primary border-b-2 border-b-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`tab-${tab.id}`}
            >
              {tab.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};
